// Import Dependencies
import React, { useState } from 'react';
import Cookies from 'js-cookie';
import endOfDayDate from '~/common/utils/endOfDayDate.js';

import Sublink from '~/common/components/Sublink';
// Import Local Styles
import styles from './free-trial-sms-banner.css';

const FreeTrialSMSBanner = () => {
    const domain = window.location.hostname === 'localhost' ? '' : '.grasshopper.com';
    const getCookie = Cookies.get('SMSBannerOpen');
    const bannerControl = getCookie !== 'false';
    const [isBannerOpen, setIsBannerOpen] = useState(bannerControl);
    const bannerCopy = 'Due to industry compliance requirements, use of local or toll-free numbers for text messaging requires registration with carriers. ';

    const closeBanner = () => {
        setIsBannerOpen(false);
        Cookies.set('SMSBannerOpen', 'false', { expires: endOfDayDate(), domain });
    };

    return (
        <div
            className={`
            ${styles.v2}
            ${styles.wrapper} ${isBannerOpen ? styles.open : ''}`}
            data-test="free-trial-sms-banner"
        >
            <div className={styles.content}>
                <p className={styles['text-container']}>
                    {bannerCopy}
                    <Sublink
                        href="https://support.grasshopper.com/help/register-your-phone-numbers-for-sms-compliance"
                        modifier={styles.link}
                        target="_blank"
                    >
                            Click to learn more.
                    </Sublink>
                </p>
                <span
                    className={styles.close}
                    onClick={() => closeBanner()}
                >
                        ×
                </span>
            </div>
        </div>
    );
};

export default FreeTrialSMSBanner;
